import { render, staticRenderFns } from "./epub.vue?vue&type=template&id=305ed44b&scoped=true"
import script from "./epub.vue?vue&type=script&lang=js"
export * from "./epub.vue?vue&type=script&lang=js"
import style0 from "./epub.vue?vue&type=style&index=0&id=305ed44b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305ed44b",
  null
  
)

export default component.exports